import { render } from "./projectsAdmin.vue?vue&type=template&id=fba6866a&scoped=true"
import script from "./projectsAdmin.vue?vue&type=script&lang=js"
export * from "./projectsAdmin.vue?vue&type=script&lang=js"

import "./projectsAdmin.vue?vue&type=style&index=0&id=fba6866a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba6866a"],['__file',"src/views/projectsAdmin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fba6866a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fba6866a', __exports__)) {
    api.reload('fba6866a', __exports__)
  }
  
  module.hot.accept("./projectsAdmin.vue?vue&type=template&id=fba6866a&scoped=true", () => {
    api.rerender('fba6866a', render)
  })

}


export default __exports__